import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

// Fetch all projects
export const fetchProject = createAsyncThunk(
  "projects/fetchProject",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/projects", {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Cancel a specific project
export const cancelProject = createAsyncThunk(
  "projects/cancelProject",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const response = await apiService.delete(`/cancel-project/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return { id, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const projectSlice = createSlice({
  name: "projects",
  initialState: {
    projects: [],
    status: "idle", // for fetchProject
    error: null,
    statusCancel: "idle", // for cancelProject
    errorCancel: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --- Fetch Project ---
      .addCase(fetchProject.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.projects = action.payload.data;
      })
      .addCase(fetchProject.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch projects";
      })

      // --- Cancel Project ---
      .addCase(cancelProject.pending, (state) => {
        state.statusCancel = "loading";
        state.errorCancel = null;
      })
      .addCase(cancelProject.fulfilled, (state, action) => {
        state.statusCancel = "succeeded";

        // Optionally remove the canceled project from state.projects
        const projectId = action.payload.id;
        state.projects = state.projects.filter((p) => p.id !== projectId);
      })
      .addCase(cancelProject.rejected, (state, action) => {
        state.statusCancel = "failed";
        state.errorCancel = action.payload || "Failed to cancel project";
      });
  },
});

export default projectSlice.reducer;
